import React from "react";
import { useAppearanceContext } from "@contexts/AppearanceContext";
import { ChatContextType, useChatContext } from "../../../features/room/room-chat/ChatContext";
import RoomChatButton from "./AllOverlayButtons/RoomChatButton";
import "./OverlayButtons.scss";

interface OverlayButtonsProps {}
export default function OverlayButtons(props: OverlayButtonsProps) {
    const { isChatOpen }: ChatContextType = useChatContext();
    const { isFocusModeActive } = useAppearanceContext();

    const chatBtns = (
        <span
            key={`overlay-buttons-chat-btns-bottom-right`}
            className={`overlay-button ${isFocusModeActive ? "focus" : ""} grouped-buttons`}
        >
            <RoomChatButton />
        </span>
    );

    // All buttons that appear at the BOTTOM of the UI should be in this array.
    const bottomRowButtons: JSX.Element[] = [chatBtns];

    const getClassNames = () => {
        const classNames = ["overlay-button-row", "dynamic-element", "bottom", isChatOpen ? "right-compressed" : ""];
        return classNames.join(" ");
    };

    return (
        <>
            <div className={getClassNames()}>{bottomRowButtons}</div>
        </>
    );
}
